export default __webpack_public_path__ + "static/media/help-rav-qa-9.67d758c4.png";